<template>
  <PageContainer title="Faturas">
    <Box class="faturas-import-container" space="medium">
      <form @submit.prevent="handleSubmit">
        <div class="radio">
          <span class="mb-3">Selecione o critério de consulta</span>

          <div class="d-flex align-items-center justify-content-between flex-wrap">
            <div class="col-md-6">
              <RadioButtons class="" :options="consultOptions" name="consult" :modelValue="consult"
                @update:modelValue="$event => this.consult = $event" />
            </div>

            <div class="col-md-6" v-if="id_role == 6">
              <Select class="" :options="schemaOptions" legend="Autoescola destino" placeholder="Selecione"
                :modelValue="schema" @update:modelValue="$event => (this.schema = $event)" />
            </div>
          </div>
        </div>

        <div v-if="consult === 'period'" class="inputs">
          <div class="inputs-row">
            <Period class="input-date" legend="Data" :firstModelValue="initialDate" :secondModelValue="finalDate"
              @update:firstModelValue="$event => (this.initialDate = $event)"
              @update:secondModelValue="$event => (this.finalDate = $event)" :disabled="loading" />
          </div>
        </div>

        <div v-else-if="consult === 'student'" class="inputs">
          <div class="inputs-row">
            <Select :filtered="true" :options="alunos" legend="Nome do aluno" placeholder="Digite o nome do aluno"
              :modelValue="aluno" @update:modelValue="$event => (this.aluno = $event)" :disabled="loadingAluno || loading" />

            <Input class="input" mask="###.###.###-##" legend="CPF do aluno" placeholder="CPF do aluno"
              :modelValue="cpf" @update:modelValue="$event => (this.cpf = $event)" :disabled="loading" />
          </div>
        </div>

        <div v-else class="inputs">
          <div class="inputs-row">
            <Input class="input" legend="Renach" placeholder="Renach" :modelValue="renach"
              @update:modelValue="$event => (this.renach = $event)" :disabled="loading" />
          </div>
        </div>

        <div class="buttons">
          <Button type="button" @handle:click="clearInputs" text="Limpar" :fill="false" color="danger"
            :disabled="loading">
            <CloseCircleOutline :size="18" />
          </Button>

          <Button type="submit" text="Consultar" color="primary" :disabled="loading">
            <Magnify :size="18" />
          </Button>
        </div>
      </form>

      <div v-if="loading" class="d-flex justify-content-center">
        <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#1C2D5A'" :size="80" class="mx-2">
        </component>
      </div>

      <div v-else-if="faturas.length > 0 && !loading" class="table-container">
        <div class="infos">
          <Button type="button" @handle:click="importFaturas" text="Importar faturas" color="primary"
            :disabled="loadingImports || selectedFaturas.length < 1">
            <TrayArrowDown :size="18" />
          </Button>
        </div>

        <Table :headers="['Aluno', 'CPF', 'Renach', 'Importar']" :selectable="true" :selected-items="selectedFaturas"
          :all-items="faturas" @select-all="selectAll" @toggle-selection="toggleSelection">
          <tr v-for="fatura in faturas" :key="fatura.id_aluno"
            :class="{ selected: selectedFaturas.includes(fatura.id_aluno) }">
            <td class="checkbox">
              <label>
                <input type="checkbox" :checked="selectedFaturas.includes(fatura.id_aluno)"
                  @change="toggleSelection(fatura)" />
                <span></span>
              </label>
            </td>
            <td>
              {{ fatura.nome }}
              <div v-for="message in messages[fatura.id_aluno]" :key="message.id_aluno" style="display: block"
                class="invalid-feedback">
                {{ message }}
              </div>
            </td>
            <td>{{ utils.formatarCPF(fatura.cpf) }}</td>
            <td>{{ fatura.renach }}</td>
            <td>
              <div class="actions">
                <div>
                  <IconButton @handle:click="importFatura(fatura)" color="primary" title="Importar fatura"
                    :disabled="loadingActions">
                    <TrayArrowDown :size="19" />
                  </IconButton>
                </div>
              </div>
            </td>
          </tr>
        </Table>
      </div>
    </Box>
  </PageContainer>
</template>

<script>
import urlApiV2 from '@/router/urlApiV2'
import * as spinners from 'epic-spinners'
import utils from '../../../services/utils'
import PageContainer from '../../core/PageContainer'
import Box from '../../core/Box'
import RadioButtons from '../../core/RadioButtons'
import Period from '../../core/Period'
import Input from '../../core/Input'
import Select from '../../core/Select'
import Button from '../../core/Button'
import Table from '../../core/Table'
import IconButton from '../../core/IconButton'
import CloseCircleOutline from 'icons/CloseCircleOutline'
import Magnify from 'icons/Magnify'
import TrayArrowDown from 'icons/TrayArrowDown'

export default {
  name: 'ImportFaturas',
  components: {
    ...spinners,
    PageContainer,
    Box,
    RadioButtons,
    Period,
    Input,
    Select,
    Button,
    Table,
    IconButton,
    CloseCircleOutline,
    Magnify,
    TrayArrowDown,
  },
  data() {
    return {
      schema: localStorage.id_role != 6 ? localStorage.schema : null,
      id_role: localStorage.id_role,
      schemaOptions: [],
      utils: utils,
      consult: 'period',
      initialDate: '',
      finalDate: '',
      aluno: '',
      cpf: '',
      renach: '',
      consultOptions: [
        { value: "period", label: "Período" },
        { value: "student", label: "Aluno" },
        { value: "renach", label: "Renach" },
      ],
      alunos: [],
      faturas: [],
      selectedFaturas: [],
      messages: [],
      loading: false,
      loadingAluno: false,
      loadingActions: false,
      loadingImports: false,
    }
  },
  async created() {
    if (this.id_role != 6) {
      await this.loadAlunos()
    }
  },
  mounted() {
    this.id_role == 6 ? this.fetchCfcs() : null
  },
  methods: {
    async handleSubmit() {
      if (this.validateInputs()) {
        this.fetchFaturas()
      }
    },
    validateInputs() {
      if (!this.schema) {
        this.toast('Selecione uma autoescola.')
        return false
      }
      switch (this.consult) {
        case 'period':
          if (!this.initialDate || !this.finalDate) {
            this.toast('Preencha todas as datas.')
            return false
          }

          const initial = new Date(this.initialDate)
          const final = new Date(this.finalDate)

          if (initial > final) {
            this.toast('A data inicial deve ser menor ou igual à data final.')
            return false
          }

          break
        case 'student':
          if (!this.aluno && !this.cpf) {
            this.toast('Preencha um dos campos.')
            return false
          }

          if (this.cpf && this.cpf.length !== 11) {
            this.toast('CPF inválido.')
            return false
          }

          break
        case 'renach':
          if (!this.renach) {
            this.toast('Preencha o campo "Renach".')
            return false
          }

          break
      }

      return true
    },
    async fetchFaturas() {
      this.loading = true

      const params = {}
      if(this.id_role == 6) {
        params.schema = this.schema
      }

      switch (this.consult) {
        case 'period':
          params.periodo = [this.initialDate, this.finalDate]

          break
        case 'student':
          if (this.aluno) params.nome = this.aluno
          if (this.cpf) params.cpf = this.cpf

          break
        case 'renach':
          params.renach = this.renach

          break
      }

      await this.$http.get(`${urlApiV2}/faturamento/importar`, {
        params,
      })
        .then(response => {
          this.faturas = Object.values(response.body.dados)
        })
        .catch(err => {
          this.toast('Erro ao buscar faturas.')
        })
        .finally(() => {
          this.loading = false
        })
    },
    async loadAlunos() {
      this.loadingAluno = true
      this.alunosOptions = []

      await this.$http.get(`${urlApiV2}/alunos/consultar/select/${this.schema}`)
        .then(response => {
          this.alunos = response.body.dados.map(item => ({ value: item.text, text: item.text }))
        })
        .catch(err => {
          this.toast(err)
        })
        .finally(() => {
          this.loadingAluno = false
        })
    },
    selectAll(isChecked) {
      if (isChecked) {
        this.selectedFaturas = this.faturas
          .map((fatura) => fatura.id_aluno)
      } else {
        this.selectedFaturas = []
      }
    },
    toggleSelection(fatura) {
      const index = this.selectedFaturas.indexOf(fatura.id_aluno)
      if (index === -1) {
        this.selectedFaturas.push(fatura.id_aluno)
      } else {
        this.selectedFaturas.splice(index, 1)
      }
    },
    async importFatura(fatura) {
      this.loadingActions = true

      await this.$http.post(`${urlApiV2}/faturamento/importar/faturas`, {schema: this.schema, id: fatura.id_aluno})
        .then(response => {
          if (response.body.sucesso === false) {
            this.toast(response.body.mensagem)

            return
          }

          this.messages = response.body.dados
        })
        .catch(err => {
          this.toast(err)
        })
        .finally(() => {
          this.loadingActions = false
        })
    },
    async importFaturas() {
      this.loadingImports = true

      await this.$http.post(`${urlApiV2}/faturamento/importar/faturas`, {schema: this.schema, id: this.selectedFaturas})
        .then(response => {
          if (response.body.sucesso === false) {
            this.toast(response.body.mensagem)

            return
          }

          this.messages = response.body.dados
        })
        .catch(err => {
          this.messages = err.body.mensagem
          this.toast(err.body.error)
        })
        .finally(() => {
          this.loadingImports = false
        })
    },
    clearInputs() {
      this.initialDate = ''
      this.finalDate = ''
      this.aluno = ''
      this.cpf = ''
      this.renach = ''
    },
    toast(text) {
      this.$toasted.show(text, {
        icon: 'fa-times',
        position: 'top-right',
        duration: 5000,
        fullWidth: false
      })
    },
    async fetchCfcs() {
      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/autoescola/todas`)
        .then((res) => {
          this.schemaOptions = res.body.dados.map(cfc => ({ value: cfc.tenant_schema, text: cfc.nome_fantasia }))
        })
        .catch((error) => {
          this.$toasted.show('Erro!' + error.body.mensagem, {
            position: 'top-right',
          })
        })
    },
  },
  watch: {
    schema(newSchema) {
      if (newSchema && this.id_role == 6) {
        this.loadAlunos()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.faturas-import-container {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  form {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;

    .radio {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      span {
        font-size: 1rem;
        font-weight: 600;
        line-height: 21.82px;
        color: #606264;
      }
    }

    .inputs {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;

      .inputs-row {
        display: flex;
        flex-wrap: wrap;
        gap: 1.5rem;

        >div {
          flex: 1;
        }

        .input-date {
          max-width: 40rem;
        }
      }
    }

    .buttons {
      align-self: flex-end;

      display: flex;
      gap: 0.5rem;
    }
  }

  .table-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .infos {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-end;
      gap: 1.5rem;
    }

    .checkbox {
      label {
        margin: 0;
        display: flex;
        align-items: center;
        gap: 0.75rem;
        font-size: 0.875rem;
        font-weight: 600;
        line-height: 19.1px;
        color: #606264;
        cursor: pointer;

        input[type="checkbox"] {
          display: none;
        }

        span {
          position: relative;
          display: inline-block;
          width: 1rem;
          height: 1rem;
          border: 2px solid #DFDCDC;
          border-radius: 2px;
          background-color: #FAFAFA;
          transition: background-color 0.2s, border-color 0.2s;
        }

        input[type="checkbox"]:checked+span {
          background-color: #1C2D5A;
        }

        input[type="checkbox"]:checked+span::after {
          content: '✓';
          color: white;
          font-size: 8px;
          position: absolute;
          top: 55%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }

    .actions {
      display: flex;
      align-items: center;

      div {
        padding: 0 0.5rem;
        display: flex;
        justify-content: center;

        &:not(:first-child) {
          border-left: 1px solid #ECECEC;
        }

        &:not(:last-child) {
          border-right: 1px solid #ECECEC;
        }
      }
    }
  }
}

#consulta_alunos {
  input.form-control {
    margin-top: 0;
  }
}

#tableAlunos {
  .faturas.btn {
    letter-spacing: 0px;
  }

  .faturas.btn.btn-micro {
    padding: 0;
    font-size: 100%;
    line-height: 1;
    border-radius: 80%;
  }

  .faturas.btn.btn-micro .fa-file,
  .fa-download {
    color: white;
    font-size: 15px;
    padding: 10px;
  }

  .badge.font-personalize {
    font-size: 0.8em;
  }

  table td {
    width: auto;
  }
}

/* Estilo iOS */

.switch {
  visibility: hidden;
  position: absolute;
  margin-left: -9999px;
}

.switch+label {
  display: inline-flex;
  position: relative;
  cursor: pointer;
  outline: none;
  user-select: none;
}

.switch--shadow+label {
  padding: 2px;
  width: 60px;
  height: 31px;
  background-color: #dddddd;
  border-radius: 30px;
  margin: 0;
}

.switch--shadow+label:before,
.switch--shadow+label:after {
  display: block;
  position: absolute;
  top: 1px;
  left: 1px;
  bottom: 1px;
  content: "";
}

.switch--shadow+label:before {
  right: 1px;
  background-color: #f1f1f1;
  border-radius: 30px;
  transition: background 0.4s;
}

.switch--shadow+label:after {
  width: 28px;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  transition: all 0.4s;
}

.switch--shadow:checked+label:before {
  background-color: #8ce196;
}

.switch--shadow:checked+label:after {
  transform: translateX(30px);
}
</style>
